import { useReopenWorkOrderComplement } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.hooks';
import { Button, Modal, Popover } from 'antd';
import { useWorkorderDetailContext } from '../../WorkorderDetailProvider';
import { WorkOrderComplementStatus } from '@/core/domain/workorder/WorkOrdersComplements/WorkOrdersComplements.types';
import { hasPermissions } from '@/utils/functions/hasPermissions';
import Authorities from '@/types/Authority';

const ComplementReopen: React.FC = () => {
  const {
    workorder: { data: workorder },
    complement: { data: complement },
  } = useWorkorderDetailContext();

  const workorderNumber = String(workorder?.number).padStart(6, '0');
  const complementNumber = String(complement?.number).padStart(2, '0');

  const reopenComplement = useReopenWorkOrderComplement();

  async function reopenOS() {
    try {
      if (workorder && complement)
        await reopenComplement.mutateAsync({
          workorderId: workorder.id,
          complementId: complement.id,
        });
    } catch {}
  }

  function confirmReopen() {
    Modal.confirm({
      title: 'Reabrir complemento',
      content: `Deseja realmente reabrir o complemento do orçamento "${workorderNumber}/${complementNumber}"?`,
      onOk: reopenOS,
      okText: 'Reabrir',
    });
  }

  const permissionReopen =
    (complement?.status === WorkOrderComplementStatus.Cancelled &&
      !hasPermissions([
        Authorities.MOVIMENTATION_WORKORDER_CANCELLED_REOPEN,
      ])) ||
    (complement?.status === WorkOrderComplementStatus.Closed &&
      !hasPermissions([Authorities.MOVIMENTATION_WORKORDER_CLOSED_REOPEN]));

  return (
    <Popover
      content={
        permissionReopen ? 'Sem permissão para reabrir a O.S' : undefined
      }
    >
      <Button block onClick={confirmReopen} disabled={permissionReopen}>
        Reabrir O.S.
      </Button>
    </Popover>
  );
};

export default ComplementReopen;
